import React from "react";
import { Box, ButtonBase, Typography, alpha } from "@mui/material";
import {
  CheckCircle as CheckedIcon,
  RadioButtonUnchecked as UncheckedIcon,
} from "@mui/icons-material";
import { COLORS, TYPO } from "../../styles/uiConstants";

/**
 * Seçilebilir modül kutusu — ad, ne işe yaradığı ve panelde nerede göründüğü.
 * Tüm kutu tıklanır (role="checkbox").
 *
 * @param {string} label
 * @param {string} [description] - Ne işe yarar, tek cümle
 * @param {string} [where] - Panelde nerede görünür ("Menü › Tedaviler")
 * @param {boolean} checked
 * @param {boolean} [disabled]
 * @param {string} [note] - Seçilemiyorsa nedeni ("Paketinizde yok")
 * @param {() => void} onToggle
 * @param {object} [palette] - Klinik teması (primary)
 */
export default function ModuleTile({
  label,
  description,
  where,
  checked,
  disabled = false,
  note,
  onToggle,
  palette,
}) {
  const tone = palette?.primary || COLORS.slate700;

  return (
    <ButtonBase
      role="checkbox"
      aria-checked={checked}
      aria-disabled={disabled}
      disabled={disabled}
      onClick={onToggle}
      sx={{
        display: "flex",
        alignItems: "flex-start",
        gap: 1.25,
        width: "100%",
        height: "100%",
        textAlign: "left",
        p: 1.5,
        borderRadius: 2,
        border: `1px solid ${checked ? alpha(tone, 0.45) : COLORS.slate200}`,
        bgcolor: checked ? alpha(tone, 0.05) : COLORS.white,
        opacity: disabled && !checked ? 0.6 : 1,
        transition: "border-color 120ms, background-color 120ms",
        "&:hover": disabled ? {} : { borderColor: alpha(tone, 0.6) },
        "&.Mui-focusVisible": { outline: `2px solid ${alpha(tone, 0.5)}`, outlineOffset: 2 },
      }}
    >
      {checked ? (
        <CheckedIcon sx={{ fontSize: 20, color: tone, mt: "1px", flexShrink: 0 }} />
      ) : (
        <UncheckedIcon sx={{ fontSize: 20, color: COLORS.slate300, mt: "1px", flexShrink: 0 }} />
      )}
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography sx={{ fontSize: TYPO.body, fontWeight: 500, color: COLORS.slate800 }}>
          {label}
        </Typography>
        {description && (
          <Typography sx={{ fontSize: TYPO.label, color: COLORS.slate600, mt: 0.25 }}>
            {description}
          </Typography>
        )}
        {where && (
          <Typography sx={{ fontSize: TYPO.caption, color: COLORS.slate400, mt: 0.75 }}>
            Görünür: {where}
          </Typography>
        )}
        {note && (
          <Typography sx={{ fontSize: TYPO.caption, color: COLORS.slate500, mt: 0.5 }}>
            {note}
          </Typography>
        )}
      </Box>
    </ButtonBase>
  );
}
